// extracted by mini-css-extract-plugin
export default {"continueButton":"JCPSDr"};